import { authenticationService } from './authenticationService';

export const handleResponse = response => {
    return response.text().then(text => {
        let data = null;
        if (text) {
            try {
                data = JSON.parse(text);
            } catch (_e) {
                if (!response.ok) {
                    if ([401, 403].indexOf(response.status) !== -1) {
                        authenticationService.logout();
                    }
                    const fallback = (text && String(text).trim()) || response.statusText;
                    return Promise.reject(fallback);
                }
                return Promise.reject(new Error('Invalid response from server'));
            }
        }
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                authenticationService.logout();
            }

            const errorMessage =
                (data && typeof data.error === 'string' && data.error) ||
                (data && typeof data.message === 'string' && data.message) ||
                response.statusText;
            return Promise.reject(errorMessage);
        }

        data.token = response.headers.get('Authorization').split('Bearer ')[1];

        return data;
    });
};
